import SideBar from "../SideBar";
import NavBar from "../NavBar";
import Footer from "../Footer";

/**
 * Chrome de page réutilisable. En mode normal, rend le layout complet
 * (SideBar + NavBar + Footer). En mode `embedded` (écran intégré dans un autre,
 * ex. onglets), ne rend QUE le contenu — pas de chrome dupliqué.
 */
const EmbeddableScreen = ({ embedded = false, currentMenu, navBarProps = {}, extra = null, children }) => {
    if (embedded) {
        return (
            <>
                {children}
                {extra}
            </>
        );
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SideBar currentMenu={currentMenu} />
                <div className="layout-page">
                    <NavBar {...navBarProps} />
                    <div className="content-wrapper">
                        {children}
                        <Footer />
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>
            <div className="layout-overlay layout-menu-toggle"></div>
            {extra}
            <div className="drag-target"></div>
        </div>
    );
};

export default EmbeddableScreen;
